import {
	ContractRatesAsSingleItemArrayComponent,
	ContractRatesComponent,
} from './contract-rates/contract-rates.component';
import {
	CustomerIdComponent,
	CustomerLinkComponent,
} from './customer-link/customer-link.component';
import {
	DivisionIdComponent,
	DivisionLinkComponent,
} from './division-link/division-link.component';
import {
	FieldManagerIdComponent,
	FieldManagerLinkComponent,
} from './field-manager-link/field-manager-link.component';
import {
	FieldTeamIdComponent,
	FieldTeamLinkComponent,
} from './field-team-link/field-team-link.component';
import {
	FieldWorkerIdComponent,
	FieldWorkerLinkComponent,
} from './field-worker-link/field-worker-link.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
	JobIdComponent,
	JobLinkComponent,
} from './job-link/job-link.component';
import {
	RailroadIdComponent,
	RailroadLinkComponent,
} from './railroad-link/railroad-link.component';
import {
	ServiceTypeComponent,
	ServiceTypeIdComponent,
} from './service-type/service-type.component';

import { AddressComponent } from './address/address.component';
import { AlertsModule } from '../alerts/alerts.module';
import { CommonModule } from '@angular/common';
import { CompanyComponent } from './company/company.component';
import { ContactComponent } from './contact/contact.component';
import { ContactDialogComponent } from './contact/contact-dialog/contact-dialog.component';
import { ContactListComponent } from './contact/contact-list/contact-list.component';
import { ContactsComponent } from './contact/contacts/contacts.component';
import { ContractRatesDialogComponent } from './contract-rates/contract-rates-dialog/contract-rates-dialog.component';
import { ContractRatesListComponent } from './contract-rates/contract-rates-list/contract-rates-list.component';
import { CurrencyInputModule } from '../currency-input/currency-input.module';
import { CustomerLinkWithAddComponent } from './customer-link-with-add/customer-link-with-add.component';
import { DivisionComponent } from './division/division.component';
import { DivisionDialogComponent } from './division/division-dialog/division-dialog.component';
import { EmailAddressComponent } from './email-address/email-address.component';
import { EmailAddressDialogComponent } from './email-address/email-address-dialog/email-address-dialog.component';
import { EmailAddressListComponent } from './contact/contact-list/email-address-list/email-address-list.component';
import { EmailAddressesComponent } from './email-address/email-addresses/email-addresses.component';
import { FieldWorkerLinkDialogComponent } from './field-worker-link/field-worker-link-dialog/field-worker-link-dialog.component';
import { FieldWorkerLinkListComponent } from './field-worker-link/field-worker-link-list/field-worker-link-list.component';
import { FilledOutFormStatusComponent } from './filled-out-form-status/filled-out-form-status.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormFieldResponseComponent } from './form-field-response/form-field-response.component';
import { FormFieldResponseVmComponent } from './form-field-response-vm/form-field-response-vm.component';
import { FormFieldResponsesComponent } from './form-field-response/form-field-responses/form-field-responses.component';
import { FormFieldResponsesVmComponent } from './form-field-response-vm/form-field-responses-vm/form-field-responses-vm.component';
import { FormMapModule } from '../form-map/form-map.module';
import { FormSectionComponent } from './form-section/form-section.component';
import { FormSectionsComponent } from './form-section/form-sections/form-sections.component';
import { FormSubSectionsComponent } from './form-section/form-subsections/form-subsections.component';
import { InvoiceWithCutoffRequestComponent } from './invoice-with-cutoff-request/invoice-with-cutoff-request.component';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { MaterialModule } from '../material/material.module';
import { NgModule } from '@angular/core';
import { OfferedServiceComponent } from './offered-service/offered-service.component';
import { OfferedServiceDialogComponent } from './offered-service/offered-service-dialog/offered-service-dialog.component';
import { PhoneNumberComponent } from './phone-number/phone-number.component';
import { PhoneNumberDialogComponent } from './phone-number/phone-number-dialog/phone-number-dialog.component';
import { PhoneNumberListComponent } from './contact/contact-list/phone-number-list/phone-number-list.component';
import { PhoneNumbersComponent } from './phone-number/phone-numbers/phone-numbers.component';
import { PrimaryEmailAddressComponent } from './email-address/primary-email-address/primary-email-address.component';
import { PrimaryPhoneNumberComponent } from './phone-number/primary-phone-number/primary-phone-number.component';
import { SharedGlobalModule } from '../shared-global.module';
import { SubdivisionComponent } from './subdivision/subdivision.component';
import { SubdivisionDialogComponent } from './subdivision/subdivision-dialog/subdivision-dialog.component';
import { TextMaskModule } from 'angular2-text-mask';
import { UnavailableDayComponent } from './unavailable-day/unavailable-day.component';
import { UnavailableDayDialogComponent } from './unavailable-day/unavailable-day-dialog/unavailable-day-dialog.component';
import { UnavailableDayListComponent } from './unavailable-day/unavailable-day-list/unavailable-day-list.component';
import { UnavailableMultiDeleteComponent } from './unavailable-day/unavailable-multi-delete/unavailable-multi-delete.component';
import { UnavailableMultiDeleteDialogComponent } from './unavailable-day/unavailable-multi-delete-dialog/unavailable-multi-delete-dialog.component';
import { UnavailableMultipleDayDialogComponent } from './unavailable-day/unavailable-multiple-day-dialog/unavailable-multiple-day-dialog.component';
import { UnavailableMultipleDaysComponent } from './unavailable-day/unavailable-multiple-days/unavailable-multiple-days.component';
import { RouterModule } from '@angular/router';
import { DivisionUploadDialogComponent } from './division/division-upload-dialog/division-upload-dialog.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        FlexLayoutModule,
        CurrencyInputModule,
        AlertsModule,
        SharedGlobalModule,
        TextMaskModule,
        LeafletModule,
        FormMapModule,
		RouterModule,
    ],
    declarations: [
        AddressComponent,
        CompanyComponent,
        ContactComponent,
        ContractRatesComponent,
        CustomerLinkComponent,
        CustomerIdComponent,
        DivisionComponent,
        DivisionLinkComponent,
        EmailAddressComponent,
        FieldManagerLinkComponent,
        FieldManagerIdComponent,
        FieldWorkerLinkComponent,
        FieldWorkerIdComponent,
        FieldTeamIdComponent,
        FieldTeamLinkComponent,
        FilledOutFormStatusComponent,
        FormFieldResponseComponent,
        FormFieldResponseVmComponent,
        InvoiceWithCutoffRequestComponent,
        OfferedServiceComponent,
        PhoneNumberComponent,
        RailroadLinkComponent,
        RailroadIdComponent,
        SubdivisionComponent,
        UnavailableDayComponent,
        DivisionDialogComponent,
        SubdivisionDialogComponent,
		DivisionUploadDialogComponent,
        ContactDialogComponent,
        EmailAddressDialogComponent,
        PhoneNumberDialogComponent,
        UnavailableDayDialogComponent,
        FieldWorkerLinkDialogComponent,
        UnavailableMultipleDayDialogComponent,
        UnavailableMultiDeleteDialogComponent,
        OfferedServiceDialogComponent,
        ContactsComponent,
        PhoneNumbersComponent,
        EmailAddressesComponent,
        UnavailableMultipleDaysComponent,
        UnavailableMultiDeleteComponent,
        ContactListComponent,
        PhoneNumberListComponent,
        EmailAddressListComponent,
        JobLinkComponent,
        JobIdComponent,
        FieldWorkerLinkListComponent,
        FormFieldResponsesComponent,
        FormFieldResponsesVmComponent,
        FormSectionsComponent,
        FormSubSectionsComponent,
        FormSectionComponent,
        UnavailableDayListComponent,
        DivisionIdComponent,
        CustomerLinkWithAddComponent,
        PrimaryPhoneNumberComponent,
        PrimaryEmailAddressComponent,
        ServiceTypeComponent,
        ServiceTypeIdComponent,
        ContractRatesAsSingleItemArrayComponent,
        ContractRatesDialogComponent,
        ContractRatesListComponent,
    ],
    exports: [
        AddressComponent,
        CompanyComponent,
        ContactComponent,
        ContractRatesComponent,
        CustomerLinkComponent,
        CustomerIdComponent,
        DivisionComponent,
        DivisionLinkComponent,
        EmailAddressComponent,
        FieldManagerLinkComponent,
        FieldManagerIdComponent,
        FieldWorkerLinkComponent,
        FieldWorkerIdComponent,
        FieldTeamIdComponent,
        FieldTeamLinkComponent,
        FilledOutFormStatusComponent,
        FormFieldResponseComponent,
        FormFieldResponseVmComponent,
        InvoiceWithCutoffRequestComponent,
        OfferedServiceComponent,
        PhoneNumberComponent,
        RailroadLinkComponent,
        RailroadIdComponent,
        SubdivisionComponent,
        UnavailableDayComponent,
        DivisionDialogComponent,
        SubdivisionDialogComponent,
        ContactDialogComponent,
        EmailAddressDialogComponent,
        PhoneNumberDialogComponent,
        UnavailableDayDialogComponent,
        FieldWorkerLinkDialogComponent,
        UnavailableMultipleDayDialogComponent,
        UnavailableMultiDeleteDialogComponent,
        OfferedServiceDialogComponent,
        ContactsComponent,
        PhoneNumbersComponent,
        EmailAddressesComponent,
        UnavailableMultipleDaysComponent,
        UnavailableMultiDeleteComponent,
        ContactListComponent,
        PhoneNumberListComponent,
        EmailAddressListComponent,
        JobLinkComponent,
        JobIdComponent,
        FieldWorkerLinkListComponent,
        FormFieldResponsesComponent,
        FormFieldResponsesVmComponent,
        FormSectionsComponent,
        FormSubSectionsComponent,
        FormSectionComponent,
        UnavailableDayListComponent,
        DivisionIdComponent,
        CustomerLinkWithAddComponent,
        PrimaryPhoneNumberComponent,
        PrimaryEmailAddressComponent,
        ServiceTypeComponent,
        ServiceTypeIdComponent,
        ContractRatesAsSingleItemArrayComponent,
        ContractRatesListComponent,
    ]
})
export class FormModelsModule {}
